module.exports = __webpack_public_path__ + "static/media/red.cdb36fac.png";